import { Cart } from "../../utils/API/Cart/cartAPISchema";
import { VoyadoEngageCart } from "../models/voyadoEngageWebTracking.models";
import { VoyadoEngageWebTrackingService } from "../voyadoEngageWebTracking.service";

export function mapCartToVoyadoEngageCart(cart: Cart): VoyadoEngageCart {
    return {
        cartRef: cart.id,
        cartUrl: location.origin + cart.url,
        locale: "nb-NO",
        items: cart.lineItems.map((item) => ({
            itemId: item.esalesKey + item.size,
            quantity: item.quantity,
        })),
    };
}